<template>
  <div class="Assignment">
    <p class="line">
        <b></b>举报人信息
    </p>
    <ul>
        <li style="margin-right: 20%;">
            <span>姓名：</span>
            <el-input v-model="name" placeholder="" class="input"></el-input>
        </li>
        <li>
            <span style="width:23%">身份证号：</span>
            <el-input v-model="id" placeholder="" class="input"></el-input>
        </li>
        <li style="margin-right: 20%;">
            <span> 手机号：</span>
            <el-input v-model="tel" placeholder="" class="input"></el-input>
        </li>
        <li>
            <span>现居地：</span>
            <el-select v-model="province" placeholder="请选择" style="width:25%" @change="handleChange1(province)">
                <el-option
                v-for="item,index in province_list"
                :key="index"
                :label="item.ss_name"
                :value="index">
                </el-option>
            </el-select>
            <el-select v-model="city" placeholder="请选择" style="width:25%" @change="handleChange2(city)">
                <el-option
                v-for="item,index in city_list"
                :key="index"
                :label="item.ss_name"
                :value="index">
                </el-option>
            </el-select>
            <el-select v-model="qu" placeholder="请选择" style="width:25%">
                <el-option
                v-for="item,index in qu_list"
                :key="index"
                :label="item.ss_name"
                :value="index">
                </el-option>
            </el-select>
        </li>
        <li class="select" style="margin-right: 20%;">
            <span> 行业(选填)：</span>
            <el-select v-model="value1" placeholder="请选择">
                <el-option
                v-for="item in options1"
                :key="item.text"
                :label="item.value"
                :value="item.text">
                </el-option>
            </el-select>
        </li>
        <li class="select">
            <span>职业(选填)：</span>
            <el-select v-model="value2" placeholder="请选择">
                <el-option
                v-for="item in options2"
                :key="item.text"
                :label="item.value"
                :value="item.text">
                </el-option>
            </el-select>

        </li>
    </ul>



    <div class="check">
        <button @click="back()">上一步</button>
        <button class="active" @click="nextone()">下一步</button>
    </div>

  </div>
</template>

<script>
export default {
  props:{

  },
  data () {
    return {
        name:'',
        id:'',
        tel:'',
        // 三级联动
        province:'',
        province_list:[],
        city:'',
        city_list:[],
        qu:'',
        qu_list:[],
        options1: [{ text: '农、林、牧、渔业', value: '农、林、牧、渔业'}, { text: '采矿业', value: '采矿业' },{ text: '制造业', value: '制造业' },{ text: '电力、热力、燃气及水生产供应业', value: '电力、热力、燃气及水生产供应业' }, { text: '建筑业', value: '建筑业' }, { text: '交通运输、仓储和邮政业', value: '交通运输、仓储和邮政业' }, { text: '信息传输、计算机服务和软件业', value: '信息传输、计算机服务和软件业' }, { text: '批发和零售业', value: '批发和零售业' }, { text: '住宿和餐饮业', value: '住宿和餐饮业' }, { text: '金融业', value: '金融业' }, { text: '房地产业', value: '房地产业' }, { text: '租赁和商务服务业', value: '租赁和商务服务业' }, { text: '科学研究和技术服务业', value: '科学研究和技术服务业' }, { text: '水利、环境和公共设施管理业', value: '水利、环境和公共设施管理业' }, { text: '居民服务、修理和其他服务业', value: '居民服务、修理和其他服务业' }, { text: '教育', value: '教育' }, { text: '卫生和社会工作', value: '卫生和社会工作' }, { text: '文化、体育和娱乐业', value: '文化、体育和娱乐业' }, { text: '公共管理、社会保障和社会组织', value: '公共管理、社会保障和社会组织' }, { text: '国际组织', value: '国际组织' }, { text: '其他', value: '其他' }],
        value1: '',
        options2: [{ text: '计算机/互联网/通信', value: '计算机/互联网/通信'}, { text: '生产/工艺/制造', value: '生产/工艺/制造' }, { text: '医疗/护理/制药', value: '医疗/护理/制药' },{ text: '金融/银行/投资/保险', value: '金融/银行/投资/保险' },{ text: '商业/服务业/个体经营', value: '商业/服务业/个体经营' },{ text: '文化/广告/传媒', value: '文化/广告/传媒' },{ text: '娱乐/艺术/表演', value: '娱乐/艺术/表演' },{ text: '律师/法务', value: '律师/法务' },{ text: '教育/培训', value: '教育/培训' },{ text: '公务员/行政/事业单位', value: '公务员/行政/事业单位' },{ text: '模特', value: '模特' },{ text: '空姐', value: '空姐' },{ text: '学生', value: '学生' },{ text: '其他', value: '其他' }],
        value2: '',
        
    }
  },
  components:{

  },
  mounted(){
    this.getcity();
    if(window.sessionStorage.getItem('Assignment4')){
        var info = JSON.parse(window.sessionStorage.getItem('Assignment4'));
        this.name = info.name;
        this.id = info.id;
        this.tel = info.tel;
        this.value1 = info.value1;
        this.value2 = info.value2;
    }
  },
  methods: {
      getcity(a){
        if(!a){
            // 获取省份列表
            var _this = this;
            this.$http.post(api.getcity).then(function(res){
                if(res.data.code == 100001){
                    // console.log(res.data.data);
                    _this.province_list = res.data.data;
                    _this.province = _this.province_list[0].ss_name;
                    _this.getcity(_this.province_list[0].ss_code);
                }else{

                };
            })
        }else{
            // 获取城市列表
            var _this = this;
            let param = new URLSearchParams();
            param.append("province", a);
            this.$http.post(api.getcity,param).then(function(res){
                if(res.data.code == 100001){
                    // console.log(res.data.data);
                    _this.city_list = res.data.data;
                    _this.city = _this.city_list[0].ss_name;
                    _this.getqu(_this.city_list[0].ss_code)
                }else{

                };
            })
        }
    },
    getqu(id){
        var _this = this;
        let param = new URLSearchParams();
        param.append("city", id);
        this.$http.post(api.getcity,param).then(function(res){
            if(res.data.code == 100001){
                // console.log(res);
                 _this.qu_list = res.data.data;
                _this.qu = _this.qu_list[0].ss_name;
            }else{

            };
        })
    },
    handleChange1(value) {
        this.getcity(this.province_list[value].ss_code);
    },
    handleChange2(value) {
        this.getqu(this.city_list[value].ss_code)
    },
    nextone(){
        if(this.name == ''){
            this.$message.error('请填写举报人姓名');
            return
        }else if(this.id == ''){
            this.$message.error('请填写举报人身份证号码');    
            return
        }else if(this.tel == ''){
            this.$message.error('请填写举报人手机号码');
            return
        }
        // 数据缓存本地
        var obj = new Object();
        obj.name = this.name;
        obj.id = this.id;
        obj.tel = this.tel;
        obj.value1 = this.value1;
        obj.value2 = this.value2;
        var a = JSON.stringify(obj);
        window.sessionStorage.setItem('Assignment4',a); 

        // ***跳转
        // this.$emit('son','5')
        // return;
        // --------------------------
        let param = new URLSearchParams();
        param.append("flag", '4');
        param.append("inform_name", this.name);
        param.append("inform_idcard", this.id);
        param.append("inform_mobile", this.tel);
        param.append("re_creditorprovince", typeof(this.province)=='string'?this.province:this.province_list[this.province].ss_name);
        param.append("re_creditorcity", typeof(this.city)=='string'?this.city:this.city_list[this.city].ss_name);
        param.append("re_creditorarea", typeof(this.qu)=='string'?this.qu:this.qu_list[this.qu].ss_name);
        param.append("inform_business", this.value1);
        param.append("inform_position", this.value2);
        param.append("orderid",window.sessionStorage.getItem('orderid'));
        var _this = this;
        this.$http.post(api.Assignment,param).then(function(res){
                // console.log(res);
            if(res.data.code == 100001){
                window.sessionStorage.setItem('orderid',res.data.data.orderid);
                _this.$emit('son','5')
            }else{
                _this.$message.error(res.data.message);
            }

        })

    },
    back(){
        this.$emit('son','3')
    }
  }   
}



</script>

<style scoped >

.Assignment{
    background:#FFFFFF;
    padding: 3% 3%;
}
.Assignment .line{
    color: #2fb8c2;
    font-weight: bold;
}
.Assignment .line b{
    display: inline-block;
    width: 5px;
    background: #2fb8c2;
    height: 20px;
    vertical-align: bottom;
    margin-right: 1rem;
    border-radius: 10px;
}
.Assignment ul{
    overflow:hidden;
}
.Assignment ul li{
    float:left;
    box-sizing: border-box;
    width:40%;
    margin-top: 10px;
    padding: 30px 0;
    border-bottom: 1px solid #d3d3d3;
    height: 100px;
    
}
.Assignment ul li span{
    display: inline-block;
    width: 21%;
    text-align:left;
}
.Assignment ul li>label{
    text-align:center;
    width:35%
    
}
.select{
    text-align: right;
}
.select span{
    float:left;
    line-height:40px;
}
.check{
    padding-top: 3%;
    text-align:center;
}
.check button{
    border: none;
    outline: none;
    padding: 20px 50px;
    border-radius: 10px;
    background: #FFFFFF;
    border: 1px solid #d3d3d3;
    margin: 0 50px;
    cursor: pointer;
}
.check button:hover{
    background:#2fb8c2;
    color:#ffffff;
}
.check button.active{
    background:#2fb8c2;
    color:#ffffff;
}
.input{
    width:75%
}
.tag{
    float: left;
    font-size: 12px;
    padding: 5px;
    border: 1px solid #f0f0f0;
    margin: 5px 5px 5px 0;
    cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/common/Assignment4.vue